import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VRow,[(_vm.floor)?_c(VCol,{staticClass:"py-0 my-0"},[_c('tour',{attrs:{"tourKey":"floor"}}),_c('the-floor',{attrs:{"floor":_vm.floor},on:{"updated":_vm.updated}})],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }